var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"grow-shrink"},[_c('transition',{attrs:{"name":"drawer"}},[_c('text-editor',{directives:[{name:"show",rawName:"v-show",value:(_vm.showEditor),expression:"showEditor"}]})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }